import store from '../store'

/**
 * 入参过滤
 *
 * @param {*} obj
 */
const getObj = (obj) => {
  const newobj = {}
  obj = Object.assign(obj, statisData.baseData())
  Object.keys(obj).forEach((key) => {
    if (obj[key] !== '' && obj[key] !== undefined && obj[key] !== null) {
      newobj[key] = obj[key]
    }
  })
  return newobj
}

/**
 * 埋点
 * login 【用户标识的注入】
 * registerPage 【静态公共属性的注入，注入之后的所有埋点都有它下面的属性】
 */
const statisData = {
  baseData: () => {
    const userInfo = store.getters.userInfo
    // 返回公共参数
    return {
      tysj_user_type: userInfo.company ? 1 : 0,
      tysj_user_type_register: userInfo.roleId,
      tysj_gas_id: userInfo.gasId,
      tysj_gas_name: userInfo.gasName,
      tysj_gas_business_name: userInfo.companyName,
      tysj_gas_business_id: userInfo.companyId,
      tysj_user_id: userInfo.userId,
      tysj_user_account: userInfo.account
    }
  },
  // 点击
  clickEvent: (name, id, obj = {}) => {
    const info = {
      tysj_click_name: name,
      tysj_click_id: id
    }
    statisData.baseEvent('tysj_click', { ...info, ...obj })
  },

  // 浏览
  pageViewEvent: (name, id, obj = {}) => {
    const info = {
      tysj_page_name: name,
      tysj_page_id: id,
      tysj_page_url: window.location.href
    }
    statisData.baseEvent('tysj_pageview', { ...info, ...obj })
  },

  // show
  showEvent: (name, id, obj = {}) => {
    const info = {
      tysj_ad_position_name: name,
      tysj_ad_position_id: id
    }
    statisData.baseEvent('tysj_show', { ...info, ...obj })
  },

  // 登录
  loginEvent: (obj = {}) => {
    statisData.baseEvent('tysj_login', { ...obj })
  },

  // 定位
  locationEvent: (obj = {}) => {
    statisData.baseEvent('tysj_location', { ...obj })
  },

  // 接口请求
  requestEvent: (obj = {}) => {
    statisData.baseEvent('tysj_api_request', { ...obj })
  },

  // 其他埋点
  anothorEvent: (name, obj = {}) => {
    // 公用登录、注册
    if (name === 'login') {
      window.sensors.login(obj)
    } else if (name === 'registerPage') {
      window.sensors.register(obj)
    }
  },

  // 基础埋点
  baseEvent: (name, obj) => {
    const newobj = getObj(obj)
    if (!window.sensors) return
    window.sensors.track(name, newobj || {})
  }

}

export default {
  statisData
}
